import { useTranslation } from 'react-i18next'

import { FileUploadConstantInputWrap } from '../../../../File'
import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../../../FilesPreviewGallery'
import Text from '../../../../Text'
import { Widget } from '../../../../Widget'
import { useApplicantProfileContext } from '../../RentalPortalApplicantProfile.hooks'

import { QA_NAME_APPLICANT_CHECKLIST } from './ApplicantDocumentChecklist.constants'
import {
  useApplicantDocumentAttach,
  useApplicantDocumentVerdict,
} from './ApplicantDocumentChecklist.hooks'
import {
  getApplicantChecklistRows,
  getHasApplicantChecklistRows,
  toApplicantDocumentPreviewFiles,
} from './ApplicantDocumentChecklist.utils'
import { ApplicantDocumentChecklistTable } from './ApplicantDocumentChecklistTable'

function ApplicantDocumentChecklist() {
  const { t } = useTranslation()

  const { applicantData, isInitiated, isPreview } = useApplicantProfileContext()

  const {
    handleRejectDocument,
    handleVerifyDocument,
    submittingKey,
    submittingStatus,
  } = useApplicantDocumentVerdict()

  const { attachingKey, getAttachInputProps, handleAttachDocument } =
    useApplicantDocumentAttach()

  const rows = getApplicantChecklistRows(applicantData)

  const previewFiles = toApplicantDocumentPreviewFiles(rows)

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({ files: previewFiles })

  return (
    <Widget
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated || !applicantData}
      qaName={QA_NAME_APPLICANT_CHECKLIST}
      title={t('RentalPortal.ApplicantProfileChecklistTitleKey')}
    >
      {getHasApplicantChecklistRows(rows) ? (
        <FileUploadConstantInputWrap
          getFileAttachInputProps={getAttachInputProps}
        >
          <ApplicantDocumentChecklistTable
            applicantData={applicantData}
            attachingKey={attachingKey}
            isPreview={isPreview}
            rows={rows}
            submittingKey={submittingKey}
            submittingStatus={submittingStatus}
            onAttach={handleAttachDocument}
            onClickFile={handleClickFile}
            onReject={handleRejectDocument}
            onVerify={handleVerifyDocument}
          />
        </FileUploadConstantInputWrap>
      ) : (
        <Text isSecondary>
          {t('RentalPortal.ApplicantProfileChecklistEmptyKey')}
        </Text>
      )}
      <FilesPreviewGallery
        files={previewFiles}
        initActive={activeFileIndex}
        onClose={handleCloseFilePreview}
      />
    </Widget>
  )
}

export default ApplicantDocumentChecklist
